import React from 'react';
import { useIntl } from 'react-intl';
import { WithStyles, withStyles } from '@material-ui/core';

import Button from '../../../Button';
import DialogActions from '../../../DialogActions';
import DialogContent from '../../../DialogContent';
import DialogTitle from '../../../DialogTitle';
import Dialog, { DialogProps } from '../../../Dialog';
import { LumaBotFlowSessionLog } from '../../../LumaBotFlowSessionLog';
import messages from './DialogFlowSessionLog.messages';
import styles from './DialogFlowSessionLog.styles';

export interface CardLumaBotFlowDialogDeleteProps
  extends Omit<DialogProps, 'classes' | 'onClose' | 'onSubmit'>,
    WithStyles<typeof styles> {
  setDialogOpen: (value: boolean) => void;
  flowId: string;
}

const DialogFlowSessionLog: React.FunctionComponent<CardLumaBotFlowDialogDeleteProps> = ({
  setDialogOpen,
  open: isDialogOpen,
  flowId,
  classes,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Dialog
      onClose={() => setDialogOpen(false)}
      open={isDialogOpen}
      fullWidth
      PaperProps={{ className: classes.paper }}
    >
      <DialogTitle>{formatMessage(messages.title)}</DialogTitle>
      <DialogContent className={classes.content} classes={{ root: classes.rootPadding }}>
        <LumaBotFlowSessionLog flowId={flowId} />
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={() => setDialogOpen(false)} variant="text">
          {formatMessage(messages.close)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(DialogFlowSessionLog);
